import { AdminDeliveryDetailTemplate } from "../../Templates/AdminDeliveryDetailTemplate";

export const AdminDeliveryDetail = () => {
  return <AdminDeliveryDetailTemplate />;
};
